export const getUserLevel = (userRoles)=>
	{ 
		return userRoles?.map((role) =>{
			return role === "Administrator" ? 3 : role === "ServiceDeskUser" ? 2 : 1;
		}).sort((a, b) => b - a)[0]};
      